document.addEventListener("DOMContentLoaded", function () {
  const toppingsWrapper = document.querySelector("#pizza-toppings-wrapper");
  if (!toppingsWrapper) return;

  const productTitle = toppingsWrapper.dataset.productTitle.trim();
  const checkboxes = document.querySelectorAll(".topping-checkbox");
  const toppingsField = document.querySelector("#toppings-line-item");
  const toppingChargeField = document.querySelector("#toppings-charge");

  const priceElement = document.querySelector("[data-price]");
  let basePrice = parseFloat(priceElement?.dataset.price || 0);

  // Determine product type + pricing
  let prices = {};
  if (productTitle === "Pizza Pretzel") {
    prices = {
      pepperoni: 0.75,
      jalapenos: 0.60
    };
  } else if (productTitle === "Double Pizza Pretzel") {
    prices = {
      pepperoni: 1.25,
      jalapenos: 1.00
    };
  } else {
    console.warn("No toppings pricing configured for this product.");
    return;
  }

  function updatePricing() {
    let selected = [];
    let toppingCharge = 0;

    checkboxes.forEach((cb) => {
      if (cb.checked) {
        selected.push(cb.dataset.topping);
        toppingCharge += prices[cb.dataset.topping];
      }
    });

    // Update hidden fields
    toppingsField.value = selected.length ? selected.join(", ") : "";
    toppingChargeField.value = toppingCharge.toFixed(2);

    // Update displayed price if theme supports dynamic price element
    if (priceElement) {
      let newPrice = basePrice + toppingCharge;
      priceElement.innerHTML = `$${newPrice.toFixed(2)}`;
    }
  }

  checkboxes.forEach((cb) => {
    cb.addEventListener("change", updatePricing);
  });
});
